import * as React from 'react'

const defaultSize = { x: 16, y: 16 }

export interface IProps {
  size?: { x: number; y: number }
  style?: React.CSSProperties
}
export const Right: React.FCC<IProps> = ({ size = defaultSize, style }) => (
  <svg
    width={size.x}
    height={size.y}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 3H4V4H14V3ZM12 12H2V13H12V12ZM12.9998 7.5H2.99982V8.5H12.9998V7.5Z"
      fill="var(--figma-color-text, rgba(0, 0, 0, 0.8))"
    />
  </svg>
)
